import React, { useContext } from "react";
import { Menu, ActionIcon } from "@mantine/core";
import {
  IconEdit,
  IconTrash,
  IconFolderPlus,
  IconArrowsMove,
  IconDots,
  IconDotsVertical,
} from "@tabler/icons-react";
import { FoldersContext } from "../contexts/FoldersContext";

const FolderMenu = ({ folder, disabledItems }) => {
  const {
    openRename,
    openDelete,
    openMove,
    openCreate,
    canCreateFolder,
    setFolderToModify,
  } = useContext(FoldersContext);

  const handleRename = (e) => {
    e.stopPropagation();
    setFolderToModify(folder);
    openRename();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setFolderToModify(folder);
    openDelete();
  };

  const handleCreateFolder = (e) => {
    e.stopPropagation();
    setFolderToModify(folder);
    openCreate();
  };

  const handleMoveFolder = (e) => {
    e.stopPropagation();
    setFolderToModify(folder);
    openMove();
  };

  return (
    <Menu
      shadow="md"
      width={180}
      withArrow
      keepMounted={false}
      withOverlay
      overlayProps={{ backgroundOpacity: 0 }}
    >
      <Menu.Target>
        <ActionIcon
          size="sm"
          variant="subtle"
          color="gray"
          onClick={(e) => e.stopPropagation()}
        >
          <IconDotsVertical size={16} stroke={2} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconEdit size={16} />}
          onClick={handleRename}
          disabled={disabledItems?.includes("rename")}
        >
          Rename
        </Menu.Item>
        <Menu.Item
          leftSection={<IconTrash size={16} />}
          color="red"
          onClick={handleDelete}
          disabled={disabledItems?.includes("delete")}
        >
          Delete
        </Menu.Item>
        <Menu.Divider />
        {canCreateFolder && (
          <Menu.Item
            leftSection={<IconFolderPlus size={16} />}
            onClick={handleCreateFolder}
            disabled={disabledItems?.includes("create")}
          >
            Create Folder
          </Menu.Item>
        )}
        <Menu.Item
          leftSection={<IconArrowsMove size={16} />}
          onClick={handleMoveFolder}
          disabled={disabledItems?.includes("move")}
        >
          Move
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default FolderMenu;
